/*
 * @Author: Teemo Ding
 * @Date: 2021-12-03 14:57:10
 * @LastEditTime: 2022-03-15 14:46:54
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/Voucher/index.tsx
 */
import React from 'react';
import { Form } from 'antd';
import { SectionWrapper } from 'src/components/Layouts';
import VoucherItem from '../VoucherItem';
import Element from 'src/layout/EditorPageLayout/Element/Elements';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Voucher = ({ vouchers, disable, currency, scTimezoneUTC }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Element>
      <SectionWrapper
        title={getI18n('allOrders.orderDetail.voucher')}
        initialValue={[]}
        containerClassName={css.section}
        titleClassName={css.sectionTitle}>
        <Form.Item name='voucherUuids'>
          <VoucherItem
            currency={currency}
            disable={disable}
            vouchers={vouchers}
            scTimezoneUTC={scTimezoneUTC}
          />
        </Form.Item>
      </SectionWrapper>
    </Element>
  );
};

export default Voucher;
